export var SPOTLIGHT_ONBOARDING_TARGET = 'rovo-chat-button';